import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { SimpleDateFormatPipe } from "./simple-date-format.pipe";
import { TruncatePipe } from "./truncate.pipe";
import { SafeHtmlPipe } from "./safe-html.pipe";
import { FullnamePipe } from "./fullname.pipe";

@NgModule({
  imports: [CommonModule],
  exports: [SimpleDateFormatPipe, TruncatePipe, FullnamePipe],
  declarations: [SimpleDateFormatPipe, TruncatePipe, SafeHtmlPipe, FullnamePipe]
})
export class SharedPipesModule {}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/shared-pipes.module.ts